import { render, staticRenderFns } from "./BilanzTableItem.vue?vue&type=template&id=5a7c4bb8&"
import script from "./BilanzTableItem.vue?vue&type=script&lang=ts&"
export * from "./BilanzTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports